export const GET_MACHINE_CLEANING_AREA_REQUEST =
  'GET_MACHINE_CLEANING_AREA_LIST_REQUEST';
export const GET_MACHINE_CLEANING_AREA_LIST_SUCCESS =
  'GET_MACHINE_CLEANING_AREA_LIST_SUCCESS';
export const GET_MACHINE_CLEANING_AREA_FAIL =
  'GET_MACHINE_CLEANING_AREA_LIST_FAIL';

export const GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_REQUEST =
  'GET_MACHINE_CLEANING_AREA_LIST_TOTAL_REQUEST';

export const GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_SUCCESS =
  'GET_MACHINE_CLEANING_AREA_LIST_TOTAL_SUCCESS';

export const GET_MACHINE_CLEANING_AREA_TOTAL_BY_ALL_FAIL =
  'GET_MACHINE_CLEANING_AREA_LIST_TOTAL_FAIL';

export const GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_REQUEST =
  'GET_MACHINE_CLEANING_AREA_LIST_TOTAL_BY_TIME_REQUEST';

export const GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_SUCCESS =
  'GET_MACHINE_CLEANING_AREA_LIST_TOTAL_BY_TIME_SUCCESS';

export const GET_MACHINE_CLEANING_AREA_TOTAL_BY_TIME_FAIL =
  'GET_MACHINE_CLEANING_AREA_LIST_TOTAL_BY_TIME_FAIL';
